import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ApplicationState } from '../../store/application-store';
import * as dashboardActions from '../actions/dashboard-actions';
import { Direction } from '../../common/enums/direction';

@Injectable()
export class DashboardScrollService {

  constructor(private store: Store<ApplicationState>) { }

  scrollUp() {
    this.store.dispatch(new dashboardActions.ScrollUp());
  }

  scrollDown() {
    this.store.dispatch(new dashboardActions.ScrollDown());
  }

  getScrollDirection(): Observable<Direction> {
    return this.store.pipe(select((state) => state.dashboard.scrollDirection));
  }

}
